// @flow
import styled, { css } from 'styled-components';
import SVGIcon from '~/core/icons/svg-icons';

export const Container = styled.div`
    display: flex;
    flex-wrap: wrap;
`;

type ItemDefinition = {
    selected: boolean,
    canBeUsed: boolean,
    theme: {
        secondaryLight: string,
        mediumGrey: string
    }
};
export const mapDefinitionToBorderColor = ({ selected, canBeUsed, theme }: ItemDefinition) => {
    const borderColorMap = new Map([
        [true, 'transparent'],
        [!canBeUsed, theme.secondaryLight],
        [selected, theme.mediumGrey]
    ]);
    return borderColorMap.get(true);
};

export const IconCell = styled.div`
    background-color: ${p => (p.canBeUsed ? p.theme.secondaryLight : p.theme.white)};
    border: solid 1px ${mapDefinitionToBorderColor};
    border-radius: 1em;
    cursor: pointer;
    display: flex;
    flex: 0 0 5.5em;
    flex-direction: column;
    height: 5.5em;
    margin: 0 0.5em 0.5em 0;
    transition: 0.3s;

    &:hover {
        box-shadow: 0 0 0.5em 0 ${p => p.theme.secondaryMedium};
    }
`;

const IconColor = css`fill: ${p => p.theme.mainBrandColor};`;
export const IconContainer = styled.div`
    align-items: center;
    display: flex;
    flex: 0 0 70%;
    justify-content: center;
    padding: 15% 0 5%;

    & > svg > g {
        ${p => (p.selected ? IconColor : null)};
    }
`;

export const IconText = styled.div`
    align-items: flex-start;
    display: flex;
    flex: 0 0 30%;
    font-size: 0.8em;
    justify-content: center;
`;

export const DiscoverIcon = styled(SVGIcon)`height: 3em;`;



// WEBPACK FOOTER //
// ./src/components/widgets/actions/filter/icons-list/styles.js